<template>
    <div>
        <b-form @submit.prevent="saveTypeSubCategory()" data-vv-scope="formTypeSubCategory">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input v-model="typeSubCategory.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formTypeSubCategory.name')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="hasValidLanguages">
                    <b-list-group>
                        <b-list-group-item v-for="language in typeSubCategory.sga_sub_category_type_languages"
                            :key="language.id" v-if="language.sga_language.code !== 'ES'">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                    <span class="fw-bold">
                                        <input v-model="language.value" type="text"
                                            class="form-control form-control-sm w-100" />
                                    </span>
                                </div>
                                <div class="ms-auto ml-2">
                                    <b-badge variant="primary">{{ language.sga_language.code }}</b-badge>
                                    <span class="text-muted"> - {{ language.sga_language.name }}</span>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelTypeSubCategory">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormTypesSubCategories',

    computed: {
        ...mapState('sgaTypesSubCategories', ['action', 'typeSubCategory']),

        hasValidLanguages() {
            return Array.isArray(this.typeSubCategory.sga_sub_category_type_languages) &&
                this.typeSubCategory.sga_sub_category_type_languages.length > 0;
        },
    },

    methods: {
        ...mapActions('sgaTypesSubCategories', ['createTypeSubCategorySga', 'getTypesSubCategoriesSga', 'updateTypeSubCategorySga']),
        ...mapMutations('sgaTypesSubCategories', ['setDefaultTypeSubCategorySga']),

        cancelTypeSubCategory() {
            this.setDefaultTypeSubCategorySga();
            this.$bvModal.hide('modal_create_typesubcategory');
        },

        async cancelAndGetTypeSubCategory() {
            this.cancelTypeSubCategory();
            await this.getTypesSubCategoriesSga();
        },

        async saveTypeSubCategory() {
            const isValid = await this.$validator.validateAll('formTypeSubCategory');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateTypeSubCategorySga(this.typeSubCategory);
            } else {
                flag = await this.createTypeSubCategorySga(this.typeSubCategory);
            }

            if (flag) {
                this.cancelAndGetTypeSubCategory();
            }
        }
    }
}
</script>
